import { type OpenApiSchemaCommunication, type OpenApiSchemaCommunicationBanner } from '#shared/api/schema';
import { matchesCommunication } from './matchesCommunication';

export type BannerCommunication = OpenApiSchemaCommunication & {
    alias: 'banner';
    details: { banner: OpenApiSchemaCommunicationBanner };
};

/**
 * Сервер уже упорядочил сообщения по приоритету и определил порядок при равном
 * приоритете. Выбираем первое подходящее сообщение, не меняя этот порядок.
 * @kind helper
 * @param communications — полученный от сервера список.
 * @param pathname — путь текущей страницы.
 * @param searchParams — query-параметры текущей страницы.
 * @param dismissedIds — закрытые в текущем сеансе сообщения.
 * @returns Первый подходящий баннер или undefined.
 */
export const selectBannerCommunication = (
    communications: OpenApiSchemaCommunication[],
    pathname: string,
    searchParams: URLSearchParams,
    dismissedIds: ReadonlySet<string>
): BannerCommunication | undefined =>
    communications.find((communication): communication is BannerCommunication => {
        // GET возвращает разные виды коммуникаций; здесь нужны только растяжки.
        if (communication.alias !== 'banner') {
            return false;
        }

        // alias задаёт тип, а текст и тему растяжки берём из details.banner; без них её не показываем.
        if (!communication.details.banner) {
            return false;
        }

        return matchesCommunication(communication, pathname, searchParams, dismissedIds);
    }) as BannerCommunication | undefined;
